<template>
  <div id="radius-token-page">
    <h2>Radius token</h2>
    <div class="radius-samples">
      <div v-for="(radius, name) in borderRadii" :key="name" :class="name" class="item-radius">
        {{ radius }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      borderRadii: {
        'radius-4xs': '$radius-4xs',
        'radius-3xs': '$radius-3xs',
        'radius-2xs': '$radius-2xs',
        'radius-xs': '$radius-xs',
        'radius-sm': '$radius-sm',
        'radius-md': '$radius-md',
        'radius-lg': '$radius-lg',
        'radius-xl': '$radius-xl',
        'radius-2xl': '$radius-2xl',
        'radius-3xl': '$radius-3xl',
        'radius-4xl': '$radius-4xl',
        'radius-pill': '$radius-pill',
        'radius-circle': '$radius-circle'
      }
    }
  }
}
</script>

<style lang="scss">
#radius-token-page {
  .radius-samples {
    display: grid;
    grid-template-columns: 1fr;

    .item-radius {
      background: white;
    }
  }

  @each $name, $value in (
    "radius-4xs": $radius-4xs,
    "radius-3xs": $radius-3xs,
    "radius-2xs": $radius-2xs,
    "radius-xs": $radius-xs,
    "radius-sm": $radius-sm,
    "radius-md": $radius-md,
    "radius-lg": $radius-lg,
    "radius-xl": $radius-xl,
    "radius-2xl": $radius-2xl,
    "radius-3xl": $radius-3xl,
    "radius-4xl": $radius-4xl,
    "radius-pill": $radius-pill,
    "radius-circle": $radius-circle
  ) {
    .#{$name} {
      border-radius: $value;
      border: 1px solid lightgray; // Add a border for visibility
      margin: 10px; // Space between samples
      display: inline-block; // Display inline for samples
      text-align: center; // Center text
      line-height: 200px; // Center text vertically
      color: #000; // Text color
    }
  }
}

</style>
